const projects = [
  {
    slug: 'pokedex',
    title: 'Pokémon Battle',
    description:
      'Two random hands of Pokémon face off. Whoever has the highest total base experience wins. How lucky are you?',
    icon: '🃏',
    tag: 'game',
    tech: 'React · API',
  },
  {
    slug: 'dice',
    title: 'Dice Roller',
    description:
      'Roll two dice and watch the animated tumble. Classic tabletop energy in your browser — no table required.',
    icon: '🎲',
    tag: 'game',
    tech: 'React · Animation',
  },
  {
    slug: 'coin',
    title: 'Coin Flipper',
    description:
      'Heads or tails? Flip a coin and track your luck over time — stats update live with every flip.',
    icon: '🪙',
    tag: 'game',
    tech: 'React · State',
  },
  {
    slug: 'number-quest',
    title: 'Number Quest',
    description:
      'A random number is shown each round. Hunt for the magic 7 — can you find the lucky button in time?',
    icon: '🔢',
    tag: 'game',
    tech: 'React · State',
  },
  {
    slug: 'colour-boxes',
    title: 'Colour Boxes',
    description:
      'A vibrant grid of animated colour blocks. Pure visual fun — no logic, just satisfying geometry and hue.',
    icon: '🎨',
    tag: 'visual',
    tech: 'React · CSS',
  },
  {
    slug: 'hangman',
    title: 'Hangman',
    description:
      'Classic word-guessing game. Guess the hidden word one letter at a time before the gallows are complete.',
    icon: '🪢',
    tag: 'game',
    tech: 'React · State',
  },
  {
    slug: 'paint-scheme-tracker',
    title: 'Paint Scheme Tracker',
    description:
      'Track your Warhammer miniature paint schemes step by step — with paint lookups across Citadel and Two Thin Coats.',
    icon: '🖌️',
    tag: 'util',
    tech: 'React · LocalStorage',
  },
];

export default projects;
